export const UpIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 466.205 466.205"
      fill="currentColor"
      width="16px"
    >
      <g>
        <g>
          <path
            d="M416.193,170.894c-0.052-0.053-0.105-0.105-0.158-0.158L253.049,7.536c-1.295-1.288-2.726-2.432-4.267-3.413l-4.693-2.56
  l-3.2-1.067h-2.347c-3.596-0.661-7.283-0.661-10.88,0h-2.133h-2.56l-3.627,1.92c-2.021,1.098-3.887,2.461-5.547,4.053
  L50.169,170.736c-10.957,10.87-11.028,28.565-0.158,39.522c0.052,0.053,0.105,0.105,0.158,0.158
  c11.045,10.538,28.421,10.538,39.467,0l97.493-97.28c4.206-4.124,10.96-4.058,15.084,0.149c1.919,1.957,3.011,4.577,3.049,7.318
  v317.653c-0.001,15.435,12.51,27.948,27.945,27.949c15.435,0.001,27.947-12.51,27.949-27.945c0-0.001,0-0.003,0-0.004V120.603
  c0.083-5.89,4.925-10.599,10.815-10.516c2.74,0.039,5.361,1.13,7.318,3.049l97.067,97.28c11.073,10.674,28.607,10.674,39.68,0
  C426.993,199.546,427.064,181.851,416.193,170.894z"
          />
        </g>
      </g>
    </svg>
  );
};

export const DownIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 466.205 466.205"
      fill="currentColor"
      width="16px"
    >
      <g>
        <g>
          <path
            d="M416.17,257.013c-0.052-0.053-0.105-0.105-0.158-0.158c-11.045-10.538-28.421-10.538-39.467,0l-97.28,97.28
  c-4.206,4.124-10.96,4.058-15.084-0.149c-1.919-1.957-3.011-4.577-3.049-7.318V27.949C261.133,12.514,248.622,0.001,233.188,0
  c-15.435-0.001-27.948,12.51-27.949,27.945c0,0.001,0,0.003,0,0.004v317.653c-0.083,5.89-4.925,10.599-10.815,10.516
  c-2.74-0.038-5.361-1.13-7.318-3.049l-97.28-97.28c-10.957-10.957-28.723-10.957-39.68,0c-10.957,10.957-10.957,28.723,0,39.68
  l163.2,163.2c1.295,1.288,2.726,2.432,4.267,3.413l4.693,2.56l3.2,1.067h2.347c3.596,0.661,7.283,0.661,10.88,0h2.133h2.773
  l3.627-1.92c2.021-1.098,3.887-2.461,5.547-4.053l163.2-163.2C426.97,285.665,427.04,267.97,416.17,257.013z"
          />
        </g>
      </g>
    </svg>
  );
};

export const RemoveIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 466.205 466.205"
      fill="currentColor"
      width="16px"
    >
      <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" />
    </svg>
  );
};

export const DimensionIcon = () => {
  return (
    <svg
      enable-background="new 0 0 32 32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Guides" />
      <g id="_x32_0" />
      <g id="_x31_9" />
      <g id="_x31_8" />
      <g id="_x31_7" />
      <g id="_x31_6" />
      <g id="_x31_5" />
      <g id="_x31_4" />
      <g id="_x31_3" />
      <g id="_x31_2" />
      <g id="_x31_1" />
      <g id="_x31_0" />
      <g id="_x30_9" />
      <g id="_x30_8">
        <path d="m11.2929688 7.7070313c.1953125.1953125.4511718.2929687.7070312.2929687s.5117188-.0976563.7070313-.2929688c.390625-.390625.390625-1.0234375 0-1.4140625l-.2929688-.2929687h14.171875l-.2929688.2929688c-.390625.390625-.390625 1.0234375 0 1.4140625.1953126.1953125.4511719.2929687.7070313.2929687s.5117188-.0976563.7070313-.2929688l2-2c.390625-.390625.390625-1.0234375 0-1.4140625l-2-2c-.390625-.390625-1.0234375-.390625-1.4140625 0s-.390625 1.0234375 0 1.4140625l.2929687.2929688h-14.171875l.2929688-.2929688c.390625-.390625.390625-1.0234375 0-1.4140625s-1.0234375-.390625-1.4140625 0l-2 2c-.390625.390625-.390625 1.0234375 0 1.4140625z" />
        <path d="m6.2929688 12.7070313c.1953125.1953125.4511718.2929687.7070312.2929687s.5117188-.0976563.7070313-.2929688c.390625-.390625.390625-1.0234375 0-1.4140625l-2-2c-.390625-.390625-1.0234375-.390625-1.4140625 0l-2 2c-.390625.390625-.390625 1.0234375 0 1.4140625s1.0234375.390625 1.4140625 0l.2929687-.2929687v14.171875l-.2929688-.2929688c-.390625-.390625-1.0234375-.390625-1.4140625 0s-.390625 1.0234375 0 1.4140625l2 2c.1953126.1953126.4511719.2929688.7070313.2929688s.5117188-.0976563.7070313-.2929688l2-2c.390625-.390625.390625-1.0234375 0-1.4140625s-1.0234375-.390625-1.4140625 0l-.2929688.2929688v-14.171875z" />
        <path d="m29 9h-19c-.5522461 0-1 .4477539-1 1v19c0 .5522461.4477539 1 1 1h19c.5527344 0 1-.4477539 1-1v-19c0-.5522461-.4472656-1-1-1zm-1 19h-17v-17h17z" />
      </g>
      <g id="_x30_7" />
      <g id="_x30_6" />
      <g id="_x30_5" />
      <g id="_x30_4" />
      <g id="_x30_3" />
      <g id="_x30_2" />
      <g id="_x30_1" />
    </svg>
  );
};

export const ChartIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      fill="currentColor"
      width="16px"
      height="16px"
      viewBox="0 0 512 512"
    >
      <g>
        <g>
          <path
            d="M484.295,445.96v-0.215H111.034c-30.647,0-55.495-24.762-55.624-55.409v-352c0-15.291-12.413-27.705-27.705-27.705
			S0,23.044,0,38.336v352c0,61.315,49.718,111.034,111.034,111.034h373.262c15.291,0,27.705-12.413,27.705-27.705
			S499.587,445.96,484.295,445.96z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M450.792,127.678c-12.285-9.192-29.681-6.701-38.872,5.584l-64.43,92.349l-91.06-68.51
			c-12.22-9.192-29.595-6.744-38.787,5.477c-0.022,0.043-0.043,0.064-0.086,0.107L138.309,276.51
			c-9.256,12.177-6.872,29.573,5.305,38.83c4.66,3.544,10.33,5.519,16.172,5.627c0,0,0,0.644,0,0.644
			c8.483-0.236,16.408-4.36,21.477-11.168l64.43-92.349l91.06,68.51c12.22,9.192,29.595,6.744,38.787-5.477
			c0.021-0.043,0.043-0.064,0.086-0.107l80.752-114.47C465.568,154.266,463.077,136.87,450.792,127.678z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg
      id="Layer_2"
      fill="#0091ff"
      width="21"
      height="21"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 28.43 24.75"
    >
      <g
        id="_レイヤー_3"
        data-name="レイヤー 3"
      >
        <g>
          <path d="M10.53,15.53l1.19,1.19,1.19,1.19-1.85,.58-1.61,.5,.5-1.61,.58-1.85m-.45-1.81l-1.05,3.37-1.05,3.37,3.37-1.05,3.37-1.05-2.32-2.32-2.32-2.32h0Z" />
          <polygon points="7.97 20.46 8.57 18.54 9.17 16.62 10.49 17.94 11.81 19.26 9.89 19.86 7.97 20.46" />
          <path d="M15.22,19.37l-6.15-6.15L22.28,0l6.15,6.15-13.21,13.21Zm-3.12-6.15l3.12,3.12L25.4,6.15l-3.12-3.12L12.1,13.21Z" />
          <path d="M23.57,24.75H4.47c-2.46,0-4.47-2-4.47-4.47v-6.38c0-2.46,2-4.47,4.47-4.47h2.36v2.24h-2.36c-1.23,0-2.23,1-2.23,2.23v6.38c0,1.23,1,2.23,2.23,2.23H23.57c1.23,0,2.23-1,2.23-2.23v-7.47h2.24v7.47c0,2.46-2,4.47-4.47,4.47Z" />
          <rect
            x="13.01"
            y="8.8"
            width="11.25"
            height="1.3"
            transform="translate(-1.22 15.95) rotate(-45)"
          />
        </g>
      </g>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg
      id="Layer_2"
      width="18"
      height="18"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.09 20.66"
    >
      <g
        id="_レイヤー_3"
        data-name="レイヤー 3"
      >
        <g>
          <polygon points="12.12 1.99 12.12 0 10.05 0 7.97 0 7.97 1.99 0 1.99 0 4.07 10.05 4.07 20.09 4.07 20.09 1.99 12.12 1.99" />
          <path d="M14.29,17.76c-.02,.37-.32,.66-.69,.66H6.49c-.37,0-.67-.29-.69-.65l-.53-12.44-2.24,.09,.53,12.45c.08,1.56,1.37,2.78,2.93,2.78h7.11c1.56,0,2.85-1.22,2.93-2.79l.53-12.44-2.24-.09-.53,12.43Z" />
          <rect
            x="11.68"
            y="6.8"
            width="1.16"
            height="9.8"
          />
        </g>
      </g>
    </svg>
  );
};

export const ScanIcon = () => {
  return (
    <svg
      id="fi_4379735"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
    >
      <path d="m23 8c-.552 0-1-.447-1-1v-4c0-.552-.449-1-1-1h-4c-.552 0-1-.447-1-1s.448-1 1-1h4c1.654 0 3 1.346 3 3v4c0 .553-.448 1-1 1z"></path>
      <path d="m21 24h-4c-.552 0-1-.447-1-1s.448-1 1-1h4c.551 0 1-.448 1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 1.654-1.346 3-3 3z"></path>
      <path d="m7 24h-4c-1.654 0-3-1.346-3-3v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .552.449 1 1 1h4c.552 0 1 .447 1 1s-.448 1-1 1z"></path>
      <path d="m1 8c-.552 0-1-.447-1-1v-4c0-1.654 1.346-3 3-3h4c.552 0 1 .447 1 1s-.448 1-1 1h-4c-.551 0-1 .448-1 1v4c0 .553-.448 1-1 1z"></path>
      <path d="m18 11c-.552 0-1-.447-1-1v-3h-10v3c0 .553-.448 1-1 1s-1-.447-1-1v-3c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v3c0 .553-.448 1-1 1z"></path>
      <path d="m21 14c0 .553-.448 1-1 1h-1v2c0 1.103-.897 2-2 2h-10c-1.103 0-2-.897-2-2v-2h-1c-.552 0-1-.447-1-1s.448-1 1-1h16c.552 0 1 .447 1 1z"></path>
    </svg>
  );
};

export const CopyIcon = () => {
  return (
    <svg
      id="fi_6639069"
      enableBackground="new 0 0 512 512"
      height="24"
      viewBox="0 0 512 512"
      width="24"
      fill="currentColor"
    >
      <g id="Copy">
        <g>
          <path d="m316 432h-240c-33.084 0-60-26.916-60-60v-312c0-33.084 26.916-60 60-60h200c16.025 0 31.093 6.241 42.426 17.573 0 0 0 0 .001.001l40 40c11.332 11.333 17.573 26.4 17.573 42.426v272c0 33.084-26.916 60-60 60zm-240-392c-11.028 0-20 8.972-20 20v312c0 11.028 8.972 20 20 20h240c11.028 0 20-8.972 20-20v-272c0-5.342-2.08-10.365-5.858-14.142l-40-40c-3.779-3.778-8.8-5.858-14.142-5.858z"></path>
        </g>
        <g>
          <path d="m436 512h-240c-11.046 0-20-8.954-20-20s8.954-20 20-20h240c11.028 0 20-8.972 20-20v-272c0-5.342-2.08-10.365-5.858-14.142l-28.283-28.283c-7.811-7.811-7.812-20.474-.001-28.284 7.811-7.811 20.474-7.811 28.284 0l28.284 28.284c11.333 11.332 17.574 26.399 17.574 42.425v272c0 33.084-26.916 60-60 60z"></path>
        </g>
        <g>
          <path d="m276 160h-160c-11.046 0-20-8.954-20-20s8.954-20 20-20h160c11.046 0 20 8.954 20 20s-8.954 20-20 20z"></path>
        </g>
        <g>
          <path d="m276 240h-160c-11.046 0-20-8.954-20-20s8.954-20 20-20h160c11.046 0 20 8.954 20 20s-8.954 20-20 20z"></path>
        </g>
        <g>
          <path d="m196 320h-80c-11.046 0-20-8.954-20-20s8.954-20 20-20h80c11.046 0 20 8.954 20 20s-8.954 20-20 20z"></path>
        </g>
      </g>
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      fill="currentColor"
      className="bi bi-arrow-repeat m-0"
      viewBox="0 0 16 16"
    >
      <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
      <path
        fillRule="evenodd"
        d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      id="Layer_2"
      fill="currentColor"
      enableBackground="new 0 0 512 512"
      height="18"
      viewBox="0 0 512 512"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path d="m256 439.98c-13.81 0-25-11.19-25-25v-317.96c0-13.81 11.19-25 25-25s25 11.19 25 25v317.96c0 13.81-11.19 25-25 25z" />
        </g>
        <g>
          <path d="m414.98 281h-317.96c-13.81 0-25-11.19-25-25s11.19-25 25-25h317.96c13.81 0 25 11.19 25 25s-11.19 25-25 25z" />
        </g>
      </g>
    </svg>
  );
};

export const FilterIcon = (param) => {
  return (
    <svg
      className={`svg-icon ${param.isDisable ? 'disabled-li' : ''}`}
      width="20px"
      height="20px"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M859.02 234.524l0.808-0.756 0.749-0.813c27.047-29.356 33.876-70.34 17.823-106.957-15.942-36.366-50.416-58.957-89.968-58.957H163.604c-38.83 0-73.043 22.012-89.29 57.444-16.361 35.683-10.632 76.301 14.949 106.004l0.97 1.126 280.311 266.85 2.032 312.074c0.107 16.502 13.517 29.805 29.995 29.805l0.2-0.001c16.568-0.107 29.912-13.626 29.804-30.194l-2.198-337.564-296.478-282.241c-9.526-11.758-11.426-26.933-5.044-40.851 6.446-14.059 19.437-22.452 34.75-22.452h624.828c15.6 0 28.69 8.616 35.017 23.047 6.31 14.391 3.924 29.831-6.354 41.497l-304.13 284.832 1.302 458.63c0.047 16.54 13.469 29.916 29.998 29.915h0.087c16.568-0.047 29.962-13.517 29.915-30.085L573.04 502.36l285.98-267.836z"></path>
      <path d="M657.265 595.287c0 16.498 13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.498 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997H687.262c-16.498 0-29.997 13.499-29.997 29.997z m273.894 138.882H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z m0 168.878H687.262c-16.498 0-29.997 13.499-29.997 29.997s13.499 29.997 29.997 29.997h243.897c16.498 0 29.997-13.499 29.997-29.997 0-16.498-13.499-29.997-29.997-29.997z"></path>
    </svg>
  );
};

export const EmailIcon = (param) => {
  return (
    <svg
      fill="#7d8ca3"
      viewBox="-42 0 512 512.001"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m210.351562 246.632812c33.882813 0 63.21875-12.152343 87.195313-36.128906 23.96875-23.972656 36.125-53.304687 36.125-87.191406 0-33.875-12.152344-63.210938-36.128906-87.191406-23.976563-23.96875-53.3125-36.121094-87.191407-36.121094-33.886718 0-63.21875 12.152344-87.191406 36.125s-36.128906 53.308594-36.128906 87.1875c0 33.886719 12.15625 63.222656 36.128906 87.195312 23.980469 23.96875 53.316406 36.125 87.191406 36.125zm-65.972656-189.292968c18.394532-18.394532 39.972656-27.335938 65.972656-27.335938 25.996094 0 47.578126 8.941406 65.976563 27.335938 18.394531 18.398437 27.339844 39.980468 27.339844 65.972656 0 26-8.945313 47.578125-27.339844 65.976562-18.398437 18.398438-39.980469 27.339844-65.976563 27.339844-25.992187 0-47.570312-8.945312-65.972656-27.339844-18.398437-18.394531-27.34375-39.976562-27.34375-65.976562 0-25.992188 8.945313-47.574219 27.34375-65.972656zm0 0" />
      <path d="m426.128906 393.703125c-.691406-9.976563-2.089844-20.859375-4.148437-32.351563-2.078125-11.578124-4.753907-22.523437-7.957031-32.527343-3.3125-10.339844-7.808594-20.550781-13.375-30.335938-5.769532-10.15625-12.550782-19-20.160157-26.277343-7.957031-7.613282-17.699219-13.734376-28.964843-18.199219-11.226563-4.441407-23.667969-6.691407-36.976563-6.691407-5.226563 0-10.28125 2.144532-20.042969 8.5-6.007812 3.917969-13.035156 8.449219-20.878906 13.460938-6.707031 4.273438-15.792969 8.277344-27.015625 11.902344-10.949219 3.542968-22.066406 5.339844-33.042969 5.339844-10.96875 0-22.085937-1.796876-33.042968-5.339844-11.210938-3.621094-20.300782-7.625-26.996094-11.898438-7.769532-4.964844-14.800782-9.496094-20.898438-13.46875-9.753906-6.355468-14.808594-8.5-20.035156-8.5-13.3125 0-25.75 2.253906-36.972656 6.699219-11.257813 4.457031-21.003906 10.578125-28.96875 18.199219-7.609375 7.28125-14.390625 16.121094-20.15625 26.273437-5.558594 9.785157-10.058594 19.992188-13.371094 30.339844-3.199219 10.003906-5.875 20.945313-7.953125 32.523437-2.0625 11.476563-3.457031 22.363282-4.148437 32.363282-.679688 9.777344-1.023438 19.953125-1.023438 30.234375 0 26.726562 8.496094 48.363281 25.25 64.320312 16.546875 15.746094 38.4375 23.730469 65.066406 23.730469h246.53125c26.621094 0 48.511719-7.984375 65.0625-23.730469 16.757813-15.945312 25.253906-37.589843 25.253906-64.324219-.003906-10.316406-.351562-20.492187-1.035156-30.242187zm-44.90625 72.828125c-10.933594 10.40625-25.449218 15.464844-44.378906 15.464844h-246.527344c-18.933594 0-33.449218-5.058594-44.378906-15.460938-10.722656-10.207031-15.933594-24.140625-15.933594-42.585937 0-9.59375.316406-19.066407.949219-28.160157.617187-8.921874 1.878906-18.722656 3.75-29.136718 1.847656-10.285156 4.199219-19.9375 6.996094-28.675782 2.683593-8.378906 6.34375-16.675781 10.882812-24.667968 4.332031-7.617188 9.316407-14.152344 14.816407-19.417969 5.144531-4.925781 11.628906-8.957031 19.269531-11.980469 7.066406-2.796875 15.007812-4.328125 23.628906-4.558594 1.050781.558594 2.921875 1.625 5.953125 3.601563 6.167969 4.019531 13.277344 8.605469 21.136719 13.625 8.859375 5.648437 20.273437 10.75 33.910156 15.152344 13.941406 4.507812 28.160156 6.796875 42.273437 6.796875 14.113282 0 28.335938-2.289063 42.269532-6.792969 13.648437-4.410156 25.058594-9.507813 33.929687-15.164063 8.042969-5.140624 14.953125-9.59375 21.121094-13.617187 3.03125-1.972656 4.902344-3.042969 5.953125-3.601563 8.625.230469 16.566406 1.761719 23.636719 4.558594 7.636719 3.023438 14.121093 7.058594 19.265625 11.980469 5.5 5.261719 10.484375 11.796875 14.816406 19.421875 4.542969 7.988281 8.207031 16.289062 10.886719 24.660156 2.800781 8.75 5.15625 18.398438 7 28.675782 1.867187 10.433593 3.132812 20.238281 3.75 29.144531v.007812c.636719 9.058594.957031 18.527344.960937 28.148438-.003906 18.449219-5.214844 32.378906-15.9375 42.582031zm0 0" />
    </svg>
  );
};

export const PasswordIcon = (param) => {
  return (
    <svg
      viewBox="0 0 32 32"
      width="20px"
      height="20px"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Layer_11"
        fill="#7d8ca3"
        data-name="Layer 11"
      >
        <path d="m24 11.57h-.53v-3.1a7.47 7.47 0 1 0 -14.94 0v3.1h-.53a4 4 0 0 0 -4 4v11.43a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-11.43a4 4 0 0 0 -4-4zm-13.47-3.1a5.47 5.47 0 1 1 10.94 0v3.1h-10.94zm15.47 18.53a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2-2v-11.43a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
        <path d="m16 17.926a1.948 1.948 0 0 0 -1.354 3.348v2.371a1 1 0 0 0 1 1h.708a1 1 0 0 0 1-1v-2.371a1.948 1.948 0 0 0 -1.354-3.348z" />
      </g>
    </svg>
  );
};

export const CloseSidePanelIcon = (param) => {
  return (
    <svg
      onClick={param.closePanelHandler}
      role="button"
      xlinkTitle="close"
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      fill="currentColor"
      className="bi bi-x ms-auto d-block"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const CloseModalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="23"
      fill="currentColor"
      className="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
    </svg>
  );
};

export const RoundTabIcon = () => {
  return (
    <svg
      height="16"
      fill="currentColor"
      viewBox="0 0 24 24"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2732655"
    >
      <path
        clipRule="evenodd"
        d="m20.6136 5.64877c.4199.36742.458 1.00751.0845 1.42204l-10.5139 11.66979c-.37544.4167-1.02006.4432-1.42843.0588l-6.08403-5.7276c-.37942-.3572-.41574-.9524-.09021-1.3593.3592-.449 1.02811-.5108 1.4556-.1263l4.72039 4.2459c.41022.369 1.04179.336 1.41138-.0737l9.0435-10.02691c.3659-.40576.99-.44254 1.4012-.08272z"
        fillRule="evenodd"
      ></path>
    </svg>
  );
};

export const ImportIcon = () => {
  return (
    <svg
      height="18"
      fill="currentColor"
      className="ImportIcon"
      width="18"
      viewBox="0 0 24 24"
    >
      <path d="m21 14a1 1 0 0 0 -1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1-1v-4a1 1 0 0 0 -2 0v4a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4a1 1 0 0 0 -1-1zm-9.71 1.71a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l4-4a1 1 0 0 0 -1.42-1.42l-2.29 2.3v-9.59a1 1 0 0 0 -2 0v9.59l-2.29-2.3a1 1 0 1 0 -1.42 1.42z" />
    </svg>
  );
};

export const TagReassignIcon = () => {
  return (
    <svg
      height="18"
      viewBox="0 0 512.0015 512"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_1946422"
    >
      <path d="m456.882812 0h-194.308593c-3.976563 0-7.792969 1.582031-10.605469 4.394531l-235.855469 235.847657c-21.484375 21.492187-21.484375 56.457031 0 77.941406l177.699219 177.695312c10.375 10.375 24.214844 16.089844 38.964844 16.09375h.003906c14.753906 0 28.59375-5.71875 38.972656-16.097656l235.847656-235.851562c2.8125-2.8125 4.394532-6.628907 4.394532-10.605469l.003906-194.308594c-.003906-30.386719-24.730469-55.109375-55.117188-55.109375zm25.113282 243.207031-231.457032 231.457031c-4.710937 4.714844-11.019531 7.308594-17.757812 7.308594-6.742188 0-13.046875-2.59375-17.757812-7.304687l-177.699219-177.695313c-9.789063-9.789062-9.789063-25.726562 0-35.519531l231.460937-231.453125h188.097656c13.847657 0 25.117188 11.265625 25.117188 25.113281zm0 0"></path>
      <path d="m379.785156 85.078125c-12.589844 0-24.425781 4.90625-33.328125 13.808594-8.902343 8.898437-13.804687 20.734375-13.804687 33.324219 0 12.589843 4.902344 24.425781 13.804687 33.328124 8.902344 8.902344 20.738281 13.804688 33.328125 13.804688 12.585938 0 24.421875-4.902344 33.324219-13.804688 8.902344-8.902343 13.804687-20.738281 13.804687-33.328124 0-12.589844-4.902343-24.425782-13.800781-33.324219-8.902343-8.902344-20.738281-13.808594-33.328125-13.808594zm12.113282 59.246094c-3.234376 3.238281-7.539063 5.019531-12.113282 5.019531-4.578125 0-8.878906-1.78125-12.113281-5.019531-3.238281-3.234375-5.019531-7.539063-5.019531-12.113281 0-4.574219 1.78125-8.878907 5.019531-12.113282 3.234375-3.238281 7.539063-5.019531 12.113281-5.019531 4.574219 0 8.875 1.78125 12.113282 5.019531 3.238281 3.234375 5.019531 7.539063 5.019531 12.113282 0 4.574218-1.785157 8.878906-5.019531 12.113281zm0 0"></path>
    </svg>
  );
};

export const ExportIcon = () => {
  return (
    <svg
      id="Layer_1"
      enableBackground="new 0 0 24 24"
      fill="currentColor"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <switch>
        <g>
          <path d="m8.7 7.7 2.3-2.3v9.6c0 .6.4 1 1 1s1-.4 1-1v-9.6l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4c-.1-.1-.2-.2-.3-.2-.2-.1-.5-.1-.8 0-.1 0-.2.1-.3.2l-4 4c-.4.4-.4 1 0 1.4s1 .4 1.4 0zm12.3 6.3c-.6 0-1 .4-1 1v4c0 .6-.4 1-1 1h-14c-.6 0-1-.4-1-1v-4c0-.6-.4-1-1-1s-1 .4-1 1v4c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-4c0-.6-.4-1-1-1z" />
        </g>
      </switch>
    </svg>
  );
};

export const PrintIcon = () => {
  return (
    <svg
      width="20px"
      height="20px"
      version="1.1"
      id="fi_839286"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      // style="enableBackground:new 0 0 512 512;"
    >
      <g>
        <g>
          <path
            d="M482,182.58V135c0-24.813-20.187-45-45-45h-23.787L327.617,4.404c-0.018-0.018-0.039-0.035-0.057-0.054
			c-2.659-2.638-6.352-4.277-10.328-4.339C317.154,0.01,317.079,0,317.001,0H105c-8.284,0-15,6.716-15,15v75H75
			c-24.813,0-45,20.187-45,45v47.58C12.541,188.772,0,205.445,0,225v182c0,24.813,20.187,45,45,45h45v45c0,8.284,6.716,15,15,15h302
			c8.284,0,15-6.716,15-15v-45h45c24.813,0,45-20.187,45-45V225C512,205.445,499.459,188.772,482,182.58z M422,120h15
			c8.271,0,15,6.729,15,15v45h-30V120z M332,51.213L370.787,90H332V51.213z M120,30h182v75c0,8.284,6.716,15,15,15h75v60H120V30z
			 M60,135c0-8.271,6.729-15,15-15h15v60H60V135z M392,482H120V332h272V482z M482,407c0,8.271-6.729,15-15,15h-45v-90h15
			c8.284,0,15-6.716,15-15s-6.716-15-15-15c-12.246,0-344.772,0-362,0c-8.284,0-15,6.716-15,15s6.716,15,15,15h15v90H45
			c-8.271,0-15-6.729-15-15V225c0-8.271,6.729-15,15-15c18.142,0,401.331,0,422,0c8.271,0,15,6.729,15,15V407z"
          ></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M347,362H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h182c8.284,0,15-6.716,15-15S355.284,362,347,362z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M347,422H165c-8.284,0-15,6.716-15,15s6.716,15,15,15h182c8.284,0,15-6.716,15-15S355.284,422,347,422z"></path>
        </g>
      </g>
      <g>
        <g>
          <path d="M105,240H75c-8.284,0-15,6.716-15,15s6.716,15,15,15h30c8.284,0,15-6.716,15-15S113.284,240,105,240z"></path>
        </g>
      </g>
    </svg>
  );
};

export const NOHistoryIcon = () => {
  return (
    <svg
      clipRule="evenodd"
      fillRule="evenodd"
      height="100"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      viewBox="0 0 64 64"
      width="100"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_7486747"
    >
      <g id="Exp-2.-F">
        <path
          d="m52 35.617h-40v18.512c0 .883.579 1.662 1.425 1.916 4.019 1.205 15.321 4.596 18 5.4.375.112.775.112 1.15 0 2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z"
          fill="#cadcf0"
        ></path>
        <path
          d="m52 35.617h-20s-.194 25.912 0 25.912.387-.028.575-.084c2.679-.804 13.981-4.195 18-5.4.846-.254 1.425-1.033 1.425-1.916 0-4.636 0-18.512 0-18.512z"
          fill="#a4bbdb"
        ></path>
        <path
          d="m32 42.106-20-6.489s-3.507 5.2-5.075 7.524c-.176.261-.219.588-.117.885.103.297.338.528.637.626 3.799 1.234 15.045 4.888 17.995 5.846.423.138.887-.021 1.137-.39 1.341-1.979 5.423-8.002 5.423-8.002z"
          fill="#e9f3fc"
        ></path>
        <path
          d="m52 35.617-20 6.489s4.082 6.023 5.423 8.002c.25.369.714.528 1.137.39 2.95-.958 14.196-4.612 17.995-5.846.299-.098.534-.329.637-.626.102-.297.059-.624-.117-.885-1.568-2.324-5.075-7.524-5.075-7.524z"
          fill="#e9f3fc"
        ></path>
        <path
          d="m27.159 21.986c-.25-.367-.713-.526-1.136-.388-2.948.957-14.197 4.612-17.996 5.847-.299.097-.535.328-.637.625s-.059.625.117.885c1.444 2.142 4.493 6.662 4.493 6.662l20-6.511s-3.592-5.283-4.841-7.12z"
          fill="#cadcf0"
        ></path>
        <path
          d="m56.493 28.955c.176-.26.219-.588.117-.885s-.338-.528-.637-.625c-3.799-1.235-15.048-4.89-17.996-5.847-.423-.138-.886.021-1.136.388-1.249 1.837-4.841 7.12-4.841 7.12l20 6.511s3.049-4.52 4.493-6.662z"
          fill="#e9f3fc"
        ></path>
        <path
          d="m52 35.617-20-6.511-20 6.511 20 6.489z"
          fill="#cadcf0"
        ></path>
        <path
          d="m32 42.106v-13l-20 6.511z"
          fill="#a4bbdb"
        ></path>
        <g fill="#347bfa">
          <path d="m27.982 31.978c-.416-.272-.791-.563-1.124-.868-.406-.373-1.039-.346-1.413.061-.373.406-.346 1.039.061 1.412.409.376.87.734 1.382 1.069.462.302 1.082.172 1.384-.29s.172-1.082-.29-1.384z"></path>
          <path d="m24.866 28.906c-.297-.403-.548-.808-.754-1.213-.25-.492-.853-.688-1.345-.438s-.688.853-.438 1.345c.254.498.562.997.927 1.492.327.444.953.539 1.398.212.444-.328.539-.954.212-1.398z"></path>
          <path d="m23.404 24.825c.01-.403.069-.794.177-1.169.152-.53-.155-1.085-.686-1.237-.53-.152-1.085.155-1.237.686-.153.536-.239 1.095-.254 1.67-.013.552.423 1.011.975 1.024.552.014 1.011-.422 1.025-.974z"></path>
          <path d="m24.942 21.485c.257-.238.545-.458.86-.657.467-.295.607-.913.313-1.379-.295-.467-.913-.607-1.38-.313-.423.267-.807.562-1.152.882-.405.375-.429 1.008-.054 1.413s1.008.429 1.413.054z"></path>
          <path d="m28.661 19.76c.503-.093 1.036-.153 1.598-.176.552-.024.98-.491.957-1.042s-.49-.98-1.042-.957c-.66.028-1.286.099-1.877.208-.542.101-.902.623-.801 1.165.1.543.622.902 1.165.802z"></path>
          <path d="m33.873 19.701c.853.01 1.647-.02 2.384-.085.55-.049.957-.535.908-1.085-.049-.549-.535-.956-1.085-.907-.675.059-1.402.087-2.184.077-.552-.006-1.005.437-1.011.988-.007.552.436 1.006.988 1.012z"></path>
          <path d="m39.544 19.003c.99-.303 1.826-.691 2.526-1.136.465-.297.603-.915.306-1.381-.296-.465-.915-.603-1.381-.306-.563.358-1.238.666-2.036.91-.527.162-.825.721-.663 1.249.161.528.721.825 1.248.664z"></path>
          <path d="m44.634 15.068c.472-.976.653-2.008.607-3.003-.026-.552-.495-.978-1.046-.952s-.978.494-.952 1.045c.032.676-.09 1.377-.41 2.04-.24.497-.032 1.096.465 1.336s1.096.031 1.336-.466z"></path>
          <path d="m43.997 8.529c-.729-.985-1.718-1.671-2.796-1.892-.541-.11-1.07.238-1.181.779-.11.541.239 1.07.779 1.181.622.127 1.17.554 1.591 1.123.329.443.956.536 1.399.208.444-.329.537-.956.208-1.399z"></path>
        </g>
        <path
          d="m30.933 6.831c1.082-6.127 10.459-5.731 5 0z"
          fill="#cadcf0"
        ></path>
        <path
          d="m30.933 8.383c1.082 6.126 10.459 5.731 5 0z"
          fill="#cadcf0"
        ></path>
        <path
          d="m30.843 8.617h6.696c.552 0 1-.448 1-1s-.448-1-1-1h-6.696c-.551 0-1 .448-1 1s.449 1 1 1z"
          fill="#347bfa"
        ></path>
      </g>
    </svg>
  );
};

export const HistoryIcon = () => {
  return (
    <svg
      id="Layer_1"
      fill="currentColor"
      height="18"
      viewBox="0 0 24 24"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
    >
      <g>
        <path d="m13.1 1a10.927 10.927 0 0 0 -10.534 8.223l-.732-1.107a1 1 0 1 0 -1.668 1.1l2.2 3.334a1.084 1.084 0 0 0 .634.425 1.024 1.024 0 0 0 .756-.145l3.3-2.223a1 1 0 1 0 -1.115-1.659l-1.501 1.012a8.909 8.909 0 1 1 8.66 11.04 8.892 8.892 0 0 1 -7.281-3.822 1 1 0 1 0 -1.64 1.143 10.881 10.881 0 0 0 19.821-6.321 10.963 10.963 0 0 0 -10.9-11z" />
        <path d="m13 5.95a1 1 0 0 0 -1 1v5.05a1.04 1.04 0 0 0 .293.707l3 3.027a1.013 1.013 0 0 0 1.414.007 1 1 0 0 0 .006-1.414l-2.713-2.738v-4.639a1 1 0 0 0 -1-1z" />
      </g>
    </svg>
  );
};

export const LeftArrowMove = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      fill="currentColor"
      width="18"
      height="18"
      viewBox="0 0 476.213 476.213"
    >
      <polygon
        points="476.213,223.107 57.427,223.107 151.82,128.713 130.607,107.5 0,238.106 130.607,368.714 151.82,347.5
      57.427,253.107 476.213,253.107 "
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};

export const RightArrowMove = () => {
  return (
    <svg
      id="Layer_2"
      height="18"
      viewBox="0 0 24 24"
      width="18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
    >
      <path d="m22.707 11.293-7-7a1 1 0 0 0 -1.414 1.414l5.293 5.293h-17.586a1 1 0 0 0 0 2h17.586l-5.293 5.293a1 1 0 1 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414z" />
    </svg>
  );
};

export const NavbarIcons = {
  FactoryIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="7"
        height="18"
        x="3"
        y="3"
        rx="1"
      ></rect>
      <rect
        width="7"
        height="7"
        x="14"
        y="3"
        rx="1"
      ></rect>
      <rect
        width="7"
        height="7"
        x="14"
        y="14"
        rx="1"
      ></rect>
    </svg>
  ),
  ProcessIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34"></path>
      <path d="M4 6h.01"></path>
      <path d="M2.29 9.62A10 10 0 1 0 21.31 8.35"></path>
      <path d="M16.24 7.76A6 6 0 1 0 8.23 16.67"></path>
      <path d="M12 18h.01"></path>
      <path d="M17.99 11.66A6 6 0 0 1 15.77 16.67"></path>
      <circle
        cx="12"
        cy="12"
        r="2"
      ></circle>
      <path d="m13.41 10.59 5.66-5.66"></path>
    </svg>
  ),

  AIMSIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M15.6 2.7a10 10 0 1 0 5.7 5.7"></path>
      <circle
        cx="12"
        cy="12"
        r="2"
      ></circle>
      <path d="M13.4 10.6 19 5"></path>
    </svg>
  ),
  HolidayCalendarIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="18"
        height="18"
        x="3"
        y="4"
        rx="2"
        ry="2"
      ></rect>
      <line
        x1="16"
        x2="16"
        y1="2"
        y2="6"
      ></line>
      <line
        x1="8"
        x2="8"
        y1="2"
        y2="6"
      ></line>
      <line
        x1="3"
        x2="21"
        y1="10"
        y2="10"
      ></line>
      <path d="M17 14h-6"></path>
      <path d="M13 18H7"></path>
      <path d="M7 14h.01"></path>
      <path d="M17 18h.01"></path>
    </svg>
  ),

  UserManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        rx="2"
      ></rect>
      <circle
        cx="12"
        cy="10"
        r="3"
      ></circle>
      <path d="M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"></path>
    </svg>
  ),
  TeplarPrintTemplateIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect
        width="8"
        height="4"
        x="8"
        y="2"
        rx="1"
        ry="1"
      ></rect>
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
      <path d="M9 12v-1h6v1"></path>
      <path d="M11 17h2"></path>
      <path d="M12 11v6"></path>
    </svg>
  ),
  ProcessTemplateManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-gantt-chart-square stroke-[1] w-5 h-5 side-menu__link__icon"
    >
      <rect
        width="18"
        height="18"
        x="3"
        y="3"
        rx="2"
      ></rect>
      <path d="M9 8h7"></path>
      <path d="M8 12h6"></path>
      <path d="M11 16h5"></path>
    </svg>
  ),
  ProductManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  ),
  TrayManagementIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="lucide lucide-hard-drive stroke-[1] w-5 h-5 side-menu__link__icon"
    >
      <line
        x1="22"
        x2="2"
        y1="12"
        y2="12"
      ></line>
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
      <line
        x1="6"
        x2="6.01"
        y1="16"
        y2="16"
      ></line>
      <line
        x1="10"
        x2="10.01"
        y1="16"
        y2="16"
      ></line>
    </svg>
  ),
  GroupManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle
        cx="12"
        cy="11"
        r="1"
      ></circle>
      <path d="M11 17a1 1 0 0 1 2 0c0 .5-.34 3-.5 4.5a.5.5 0 0 1-1 0c-.16-1.5-.5-4-.5-4.5Z"></path>
      <path d="M8 14a5 5 0 1 1 8 0"></path>
      <path d="M17 18.5a9 9 0 1 0-10 0"></path>
    </svg>
  ),
  ActiveTrayManagementIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6 19v-3"></path>
      <path d="M10 19v-3"></path>
      <path d="M14 19v-3"></path>
      <path d="M18 19v-3"></path>
      <path d="M8 11V9"></path>
      <path d="M16 11V9"></path>
      <path d="M12 11V9"></path>
      <path d="M2 15h20"></path>
      <path d="M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z"></path>
    </svg>
  ),
  OrderTableViewIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"></path>
      <polyline points="10 2 10 10 13 7 16 10 16 2"></polyline>
    </svg>
  ),
};

export const AddFileIcon = () => {
  return (
    <svg
      id="Layer_1"
      height="18"
      fill="currentColor"
      viewBox="0 0 512 512"
      width="18"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
    >
      <path d="m334.269 285.546a12.673 12.673 0 0 1 -12.669 12.673h-83.139v83.134a12.673 12.673 0 1 1 -25.346 0v-83.134h-83.134a12.673 12.673 0 1 1 0-25.346h83.134v-83.135a12.673 12.673 0 0 1 25.346 0v83.135h83.139a12.673 12.673 0 0 1 12.669 12.673zm177.731-213.156v308.129a71.827 71.827 0 0 1 -61.426 70.974 71.826 71.826 0 0 1 -70.721 59.841h-308.129a71.8 71.8 0 0 1 -71.724-71.724v-308.129a71.827 71.827 0 0 1 61.425-70.974 71.827 71.827 0 0 1 70.722-59.841h308.129a71.8 71.8 0 0 1 71.724 71.724zm-85.77 59.091a46.43 46.43 0 0 0 -46.377-46.381h-308.129a46.43 46.43 0 0 0 -46.377 46.378v308.132a46.43 46.43 0 0 0 46.377 46.378h308.129a46.43 46.43 0 0 0 46.377-46.378zm60.423-59.091a46.43 46.43 0 0 0 -46.377-46.378h-308.129a46.45 46.45 0 0 0 -44.614 33.745h292.32a71.8 71.8 0 0 1 71.723 71.724v294.019a46.455 46.455 0 0 0 35.077-44.979z" />
    </svg>
  );
};

export const FileCaptionIcon = () => {
  return (
    <svg
      id="layer_1"
      fill="currentColor"
      enableBackground="new 0 0 32 32"
      height="18"
      width="18"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m10.2119141 16.8720703-.9228516 3.3833008c-.1904297.7011719.0019531 1.4262695.515625 1.9399414.3837891.3833008.8837891.5874023 1.4042969.5874023.1777344 0 .3583984-.0239258.5361328-.0722656l3.3828125-.9223633h.0009766c.8369141-.2285156 1.6044922-.6743164 2.21875-1.2885742l11.4414062-11.440918c1.6113281-1.6118164 1.6113281-4.2348633 0-5.8476562-1.6132812-1.6123047-4.2363281-1.6123047-5.8476562 0l-11.4414063 11.4414063c-.6132812.6137695-1.0585938 1.3813476-1.2880859 2.2197265zm17.1630859-12.2470703c.8320312.8325195.8320312 2.1870117 0 3.0195312l-11.4414062 11.440918c-.3691406.3686523-.8291016.6357422-1.3310547.7729492l-3.3837891.9228516.9228516-3.3823242c.1376953-.5039062.4042969-.9648438.7724609-1.3330078l11.4414063-11.440918c.4160156-.4160156.9628906-.6240234 1.5097656-.6240234s1.09375.2080078 1.5097656.6240234z" />
      <path d="m7 30h15.7001953c2.7568359 0 5-2.2431641 5-5v-9.6098633c0-.5522461-.4472656-1-1-1s-1 .4477539-1 1v9.6098633c0 1.6542969-1.3457031 3-3 3h-15.7001953c-1.6542969 0-3-1.3457031-3-3v-15.7001953c0-1.6542969 1.3457031-3 3-3h9.6103516c.5527344 0 1-.4477539 1-1s-.4472656-1-1-1h-9.6103516c-2.7568359 0-5 2.2431641-5 5v15.7001953c0 2.7568359 2.2431641 5 5 5z" />
    </svg>
  );
};

export const ClearFilterIcon = (props: any) => {
  return (
    <div
      className={`${props.className}`}
      onClick={props.onClick}
    >
      <svg
        id="Capa_1"
        enableBackground="new 0 0 512 512"
        height="23"
        viewBox="0 0 512 512"
        width="23"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="m385.606 116.606c2.798-2.798 4.379-6.632 4.391-10.562 0-.015.002-.029.002-.044v-60c0-8.284-6.716-15-15-15h-359.999c-8.284 0-15 6.716-15 15v60c0 .015.002.029.002.044.011 3.863 1.548 7.719 4.391 10.562l145.607 145.607v203.787c0 6.067 3.655 11.537 9.26 13.858 5.605 2.322 12.057 1.038 16.347-3.251l60-60c2.812-2.814 4.393-6.629 4.393-10.607v-143.787zm-355.606-55.606h330v30h-330zm184.394 184.393c-2.813 2.813-4.394 6.628-4.394 10.607v143.787l-30 30v-173.787c0-3.978-1.581-7.794-4.394-10.607l-124.393-124.393h287.574z" />
          <path d="m432.606 320.393c-5.857-5.858-15.355-5.858-21.213 0l-19.393 19.394-19.394-19.394c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l19.394 19.394-19.393 19.393c-5.858 5.858-5.858 15.355 0 21.213 5.857 5.857 15.355 5.858 21.213 0l19.393-19.393 19.394 19.394c5.857 5.857 15.355 5.858 21.213 0s5.858-15.355 0-21.213l-19.394-19.394 19.393-19.393c5.858-5.858 5.858-15.356 0-21.214z" />
          <path d="m392 241c-66.168 0-120 53.832-120 120s53.832 120 120 120 120-53.832 120-120-53.832-120-120-120zm0 210c-49.626 0-90-40.374-90-90s40.374-90 90-90 90 40.374 90 90-40.374 90-90 90z" />
        </g>
      </svg>
    </div>
  );
};

export const ExportTrayIcon = () => {
  return (
    <svg
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clip-rule="evenodd"
        fill-rule="evenodd"
      >
        <path d="m5 2.74988c-.13807 0-.25.11193-.25.25v18.00002c0 .138.11195.25.25.25h7c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-7c-.96652 0-1.75-.7836-1.75-1.75v-18.00002c0-.9665.7835-1.75 1.75-1.75h14c.9665 0 1.75.78351 1.75 1.75v9.00002c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-9.00002c0-.13808-.1119-.25-.25-.25z" />
        <path d="m17.75 14.7499c.4142 0 .75.3358.75.75v6.5c0 .4142-.3358.75-.75.75s-.75-.3358-.75-.75v-6.5c0-.4142.3358-.75.75-.75z" />
        <path d="m17.75 14.2499c.1989 0 .3897.079.5303.2196l2.25 2.25c.2929.2929.2929.7678 0 1.0607s-.7677.2929-1.0606 0l-1.7197-1.7197-1.7197 1.7197c-.2929.2929-.7677.2929-1.0606 0s-.2929-.7678 0-1.0607l2.25-2.25c.1406-.1406.3314-.2196.5303-.2196z" />
        <path d="m7.25 7.99988c0-.41422.33579-.75.75-.75h8c.4142 0 .75.33578.75.75 0 .41421-.3358.75-.75.75h-8c-.41421 0-.75-.33579-.75-.75z" />
        <path d="m7.25 11.9999c0-.4142.33579-.75.75-.75h4c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-4c-.41421 0-.75-.3358-.75-.75z" />
      </g>
    </svg>
  );
};

export const SaveIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="fi_2874091"
      viewBox="0 0 32 32"
      width={props.width || '20'}
      height={props.height || '20'}
      fill="currentColor"
    >
      <path d="M30.71,7.29l-6-6A1,1,0,0,0,24,1H4A3,3,0,0,0,1,4V28a3,3,0,0,0,3,3H28a3,3,0,0,0,3-3V8A1,1,0,0,0,30.71,7.29ZM20,3V9H12V3ZM8,29V22a1,1,0,0,1,1-1H23a1,1,0,0,1,1,1v7Zm21-1a1,1,0,0,1-1,1H26V22a3,3,0,0,0-3-3H9a3,3,0,0,0-3,3v7H4a1,1,0,0,1-1-1V4A1,1,0,0,1,4,3h6V9a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V3h1.59L29,8.41Z"></path>
    </svg>
  );
};

export const ConfirmPrintIcon = () => {
  return (
    <svg
      height="512"
      viewBox="0 0 58 58"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      id="fi_4072527"
    >
      <g
        id="Page-1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="089---Printer">
          <path
            id="Path"
            d="m12 8h-3c-1.10320187.0032948-1.9967052.89679813-2 2v7h32v-7c-.0032948-1.10320187-.8967981-1.9967052-2-2z"
            fill="#2980ba"
          ></path>
          <path
            id="Path"
            d="m8 40h-6c-1.10320187-.0032948-1.9967052-.8967981-2-2v-22c.0032948-1.1032019.89679813-1.9967052 2-2h42c1.1032019.0032948 1.9967052.8967981 2 2v24z"
            fill="#3b97d3"
          ></path>
          <path
            id="Path"
            d="m34 2v12h-22v-12c.0032948-1.10320187.8967981-1.9967052 2-2h18c1.1032019.0032948 1.9967052.89679813 2 2z"
            fill="#ecf0f1"
          ></path>
          <path
            id="Path"
            d="m12 27v13h-4v-10c0-1.6568542 1.34314575-3 3-3z"
            fill="#285680"
          ></path>
          <path
            id="Path"
            d="m30.32 47h-16.32c-1.1032019-.0032948-1.9967052-.8967981-2-2v-18h22v7.21z"
            fill="#ecf0f1"
          ></path>
          <circle
            id="Oval"
            cx="6"
            cy="20"
            fill="#65ddb9"
            r="2"
          ></circle>
          <circle
            id="Oval"
            cx="13"
            cy="20"
            fill="#65ddb9"
            r="2"
          ></circle>
          <path
            id="Path"
            d="m41 20h-4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            fill="#9fc9d3"
          ></path>
          <g fill="#95a5a5">
            <path
              id="Path"
              d="m30 32h-13c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h13c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            ></path>
            <path
              id="Path"
              d="m28.43 36h-11.43c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h11.43c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            ></path>
            <path
              id="Path"
              d="m26.74 40h-9.74c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h9.74c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            ></path>
            <path
              id="Path"
              d="m26.06 44h-9.06c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h9.06c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
            ></path>
          </g>
          <path
            id="Path"
            d="m38 30v1.35c-1.4945522.7048978-2.8496064 1.6737615-4 2.86v-7.21h1c1.6568542 0 3 1.3431458 3 3z"
            fill="#285680"
          ></path>
          <path
            id="Path"
            d="m58 44c.0035917 6.3197653-4.2272346 11.8583806-10.3254327 13.5171229s-12.5515974-.9737068-15.7496751-6.424555c-3.1980777-5.4508481-2.3478062-12.3684481 2.0751078-16.8825679 1.1503936-1.1862385 2.5054478-2.1551022 4-2.86 1.8739796-.8927382 3.9242436-1.3540476 6-1.35.669087.0007836 1.3373289.0475606 2 .14 6.8869415.9988245 11.9970549 6.9010054 12 13.86z"
            fill="#4fba6f"
          ></path>
          <path
            id="Path"
            d="m39 52c-.2651948-.0000566-.5195073-.1054506-.707-.293l-4-4c-.3789722-.3923789-.3735524-1.0160848.0121814-1.4018186s1.0094397-.3911536 1.4018186-.0121814l3.346 3.345 13.3-11.4c.4212323-.3340753 1.0312217-.2753078 1.3809275.133041.3497059.4083488.3139582 1.020119-.0809275 1.384959l-14 12c-.1810749.1574945-.4130154.2441614-.653.244z"
            fill="#fff"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const FactoryScheduleExportIcon = () => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      fill="currentColor"
      width="20"
      height="20"
      x="0px"
      y="0px"
      viewBox="0 0 405.2 512"
    >
      <g>
        <path
          d="M185.9,165.8l-40,40c-7.8,7.8-7.8,20.5,0,28.3s20.5,7.8,28.3,0l5.9-5.9V300c0,11,9,20,20,20s20-9,20-20v-71.7l5.9,5.9
                  c7.8,7.8,20.5,7.8,28.3,0c7.8-7.8,7.8-20.5,0-28.3l-40-40C206.4,158,193.6,158.1,185.9,165.8L185.9,165.8z"
        />
        <path
          d="M394.1,125.8l-120-120C273.9,5.7,268.7,0,260,0H60C26.9,0,0,26.9,0,60v392c0,33.1,26.9,60,60,60h40c11,0,20-9,20-20
                  s-9-20-20-20H60c-11,0-20-9-20-20V60c0-11,9-20,20-20h180v60c0,33.1,26.9,60,60,60h60v140c0,11,9,20,20,20s20-9,20-20V140
                  C400,134.7,397.9,129.6,394.1,125.8L394.1,125.8z M300,120c-11,0-20-9-20-20V68.3l51.7,51.7H300z"
        />
      </g>
      <g>
        <path
          d="M156.2,449.4c0,22.5,9.4,33.7,28.3,33.7c3.4,0,6.6-0.3,9.6-1s6.7-1.7,11-3.2c3.5,7.6,5.8,15.5,7,23.5
                  c-3.1,1.2-5.9,2.1-8.6,2.9c-2.6,0.7-5.2,1.3-7.6,1.7c-2.4,0.4-4.8,0.6-7.2,0.8c-2.4,0.2-4.8,0.2-7.4,0.2c-9,0-16.9-1.5-23.8-4.4
                  c-6.8-2.9-12.6-7-17.2-12.2c-4.6-5.2-8.1-11.4-10.4-18.6c-2.3-7.2-3.5-15-3.5-23.5c0-8.5,1.2-16.3,3.7-23.6
                  c2.4-7.3,6-13.5,10.6-18.8c4.6-5.3,10.3-9.4,17.1-12.4c6.8-3,14.5-4.4,23-4.4c5.1,0,9.9,0.4,14.5,1.1c4.6,0.7,9.6,2.2,15.3,4.4
                  c-0.2,4.3-1,8.6-2.4,12.6c-1.4,4.1-2.8,7.7-4.3,10.7c-2.1-0.7-4.1-1.4-5.8-1.9c-1.7-0.5-3.4-1-5-1.3s-3.2-0.6-4.8-0.7
                  s-3.3-0.2-5.1-0.2c-8.6,0-15.2,2.9-19.9,8.7C158.6,429.4,156.2,438,156.2,449.4z"
        />
        <path
          d="M270.8,436.5c4.4,1.8,8.4,3.6,12,5.5c3.5,1.9,6.6,4.1,9.1,6.7c2.5,2.6,4.5,5.7,5.9,9.4c1.4,3.7,2.1,8.1,2.1,13.3
                  c0,5.6-1,10.7-2.9,15.2c-2,4.5-4.8,8.4-8.7,11.6c-3.8,3.2-8.5,5.7-14.1,7.5c-5.6,1.7-11.9,2.6-19.1,2.6c-6.6,0-12.4-0.5-17.4-1.6
                  c-5-1.1-10.5-2.7-16.3-4.9c0.4-3.7,1.2-7.7,2.2-11.8c1.1-4.2,2.3-8.4,3.8-12.8c9.7,4.2,18.2,6.4,25.4,6.4c5.4,0,9.6-0.8,12.6-2.5
                  c3-1.6,4.5-4.5,4.5-8.5c0-1.7-0.3-3.2-1-4.4c-0.6-1.2-1.5-2.2-2.5-3.1c-1.1-0.8-2.3-1.6-3.6-2.1c-1.3-0.6-2.7-1.1-4.1-1.7l-8.9-3.3
                  c-3.8-1.4-7.3-3-10.4-4.9c-3.1-1.9-5.8-4.2-8-6.8c-2.2-2.6-3.9-5.6-5.2-9c-1.2-3.4-1.8-7.4-1.8-11.9c0-5.6,1-10.6,2.9-14.9
                  c1.9-4.3,4.6-8,8-11c3.4-3,7.6-5.3,12.5-6.8c4.9-1.5,10.3-2.3,16.4-2.3c5.4,0,10.6,0.5,15.7,1.6c5,1.1,10.4,2.6,16.1,4.6
                  c-0.4,3.4-1.2,7.1-2.3,11.2c-1.1,4.1-2.5,7.9-4.2,11.5c-2.8-1.2-6-2.4-9.7-3.7c-3.7-1.3-8.3-1.9-13.8-1.9c-1.7,0-3.3,0.2-4.8,0.5
                  c-1.5,0.3-2.9,0.8-4.1,1.5c-1.2,0.7-2.2,1.6-2.9,2.9c-0.7,1.2-1.1,2.7-1.1,4.5c0,3.1,1,5.3,3,6.8c2,1.5,4.4,2.8,7.2,3.8
                  L270.8,436.5z"
        />
        <path
          d="M354.5,469.3l21.8-76.9c2.4-0.4,4.9-0.7,7.4-1c2.5-0.2,5.1-0.3,7.9-0.3c1.8,0,4,0.1,6.7,0.4c2.6,0.3,5,0.6,7,0.9L368.7,506
                  c-2.8,0.4-5.3,0.7-7.7,1c-2.4,0.2-4.7,0.3-6.9,0.3c-2.1,0-4.3-0.1-6.5-0.3c-2.2-0.2-4.9-0.5-7.9-1l-36.4-113.6
                  c1.8-0.3,4.2-0.6,7.1-0.9c3-0.3,5.8-0.4,8.6-0.4c2.2,0,4.7,0.1,7.3,0.4c2.6,0.3,5,0.6,7,0.9L354.5,469.3z"
        />
      </g>
    </svg>
  );
};

export const CheckMarkIcon = () => {
  return (
    <svg
      clip-rule="evenodd"
      fill-rule="evenodd"
      image-rendering="optimizeQuality"
      shape-rendering="geometricPrecision"
      text-rendering="geometricPrecision"
      viewBox="0 0 254000 254000"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
    >
      <g id="&#x56FE;&#x5C42;_x0020_1">
        <path
          d="m37253 0h179494c20518 0 37253 16735 37253 37253v179494c0 20518-16735 37253-37253 37253h-179494c-20518 0-37253-16735-37253-37253v-179494c0-20518 16735-37253 37253-37253z"
          fill="none"
        />
        <g
          id="_228534408"
          fill="#48b02c"
        >
          <path
            id="_228534648"
            d="m96229 162644 89510-89509c2637-2638 6967-2611 9578 0l8642 8642c2611 2611 2611 6968 0 9578l-89509 89510c-2611 2611-6941 2638-9579 0l-8642-8642c-2638-2638-2638-6941 0-9579z"
          />
          <path
            id="_228534744"
            d="m68270 108089 54525 54525c2637 2638 2606 6973 0 9579l-8642 8642c-2606 2605-6973 2605-9579 0l-54525-54525c-2606-2606-2637-6941 0-9579l8642-8642c2638-2637 6941-2637 9579 0z"
          />
        </g>
      </g>
    </svg>
  );
};

export const SingleModeIcon = () => {
  return (
    <svg
      id="fi_11653999"
      width="80"
      height="80"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clip-rule="evenodd"
        fill-rule="evenodd"
      >
        <path
          d="m73.093 331h91.07v27.55c0 11.366 9.299 20.665 20.665 20.665h142.346c11.366 0 20.665-9.299 20.665-20.665v-27.55h91.07c13.049 0 23.725 10.676 23.725 23.725v102.55c0 13.049-10.676 23.725-23.725 23.725h-365.816c-13.049 0-23.725-10.676-23.725-23.725v-102.55c0-13.049 10.676-23.725 23.725-23.725z"
          fill="#60b7ff"
        ></path>
      </g>
    </svg>
  );
};

export const BatchModeIcon = () => {
  return (
    <svg
      id="fi_11653999"
      width="80"
      height="80"
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        clip-rule="evenodd"
        fill-rule="evenodd"
      >
        <path
          d="m73.093 331h91.07v27.55c0 11.366 9.299 20.665 20.665 20.665h142.346c11.366 0 20.665-9.299 20.665-20.665v-27.55h91.07c13.049 0 23.725 10.676 23.725 23.725v102.55c0 13.049-10.676 23.725-23.725 23.725h-365.816c-13.049 0-23.725-10.676-23.725-23.725v-102.55c0-13.049 10.676-23.725 23.725-23.725z"
          fill="#60b7ff"
        ></path>
        <path
          d="m73.093 181h91.07v27.549c0 11.366 9.299 20.665 20.665 20.665h142.346c11.366 0 20.665-9.299 20.665-20.665v-27.549h91.07c13.049 0 23.725 10.676 23.725 23.725v102.551c0 13.049-10.676 23.725-23.725 23.725h-365.816c-13.049 0-23.725-10.676-23.725-23.725v-102.551c0-13.049 10.676-23.725 23.725-23.725z"
          fill="#00e499"
        ></path>
        <path
          d="m73.093 31h91.07v27.55c0 11.366 9.299 20.664 20.665 20.664h142.346c11.366 0 20.665-9.299 20.665-20.664v-27.55h91.07c13.049 0 23.725 10.676 23.725 23.725v102.55c0 13.049-10.676 23.725-23.725 23.725h-365.816c-13.049 0-23.725-10.676-23.725-23.725v-102.55c0-13.049 10.676-23.725 23.725-23.725z"
          fill="#fd4755"
        ></path>
        <path d="m73.093 172.998c-8.67 0-15.723-7.058-15.723-15.728v-102.553c0-8.67 7.053-15.718 15.723-15.718h83.067v19.552c0 15.798 12.864 28.657 28.667 28.657h142.346c15.803 0 28.662-12.859 28.662-28.657v-19.552h83.067c8.67 0 15.732 7.048 15.732 15.718v102.553c0 8.67-7.062 15.728-15.732 15.728zm99.067 16.004h167.676v19.547c0 6.978-5.68 12.658-12.663 12.658h-142.346c-6.983 0-12.667-5.68-12.667-12.658zm282.475 15.719c0-8.67-7.062-15.718-15.732-15.718h-83.067v19.547c0 15.798-12.86 28.662-28.662 28.662h-142.347c-15.803 0-28.667-12.864-28.667-28.662v-19.547h-83.067c-8.67 0-15.723 7.049-15.723 15.718v102.549c0 8.67 7.053 15.728 15.723 15.728h365.809c8.67 0 15.732-7.058 15.732-15.728v-102.549zm-282.475 134.28h167.676v19.547c0 6.978-5.68 12.663-12.663 12.663h-142.346c-6.983 0-12.667-5.685-12.667-12.663zm282.475 15.719c0-8.67-7.062-15.718-15.732-15.718h-83.067v19.547c0 15.803-12.86 28.662-28.662 28.662h-142.347c-15.803 0-28.667-12.859-28.667-28.662v-19.547h-83.067c-8.67 0-15.723 7.048-15.723 15.718v102.549c0 8.67 7.053 15.732 15.723 15.732h365.809c8.67 0 15.732-7.062 15.732-15.732v-102.549zm15.999-197.449v-102.554c0-17.49-14.228-31.718-31.732-31.718h-91.067c-4.419 0-8 3.58-8 8v27.552c0 6.978-5.68 12.658-12.663 12.658h-142.345c-6.983 0-12.667-5.68-12.667-12.658v-27.552c0-4.419-3.58-8-8-8h-91.067c-17.495 0-31.727 14.228-31.727 31.718v102.553c0 9.429 4.143 17.907 10.695 23.728-6.552 5.811-10.695 14.293-10.695 23.723v102.549c0 9.429 4.143 17.912 10.695 23.732-6.552 5.807-10.695 14.289-10.695 23.718v102.549c0 17.504 14.233 31.732 31.727 31.732h365.809c17.504 0 31.732-14.228 31.732-31.732v-102.549c0-9.429-4.138-17.912-10.699-23.718 6.561-5.821 10.699-14.303 10.699-23.732v-102.549c0-9.429-4.138-17.912-10.699-23.723 6.561-5.82 10.699-14.298 10.699-23.727z"></path>
      </g>
    </svg>
  );
};
